import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const PaymentFrequencyLineChart = ({ monthlyPaymentFrequency }) => {
    const labels = monthlyPaymentFrequency.map(item => item.month);
    const dataPoints = monthlyPaymentFrequency.map(item => parseFloat(item.frequency));

    const data = {
        labels,
        datasets: [
            {
                label: 'Payment Frequency',
                data: dataPoints,
                borderColor: '#F8A81B',
                backgroundColor: 'transparent',
                borderWidth: 2,
                fill: false,
                tension: 0.4,
                pointRadius: 0,
                pointHoverRadius: 6, 
                pointHoverBackgroundColor: '#3b82f6',
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                ticks: {
                    color: '#000',
                },
                grid: {
                    display: false,
                },
            },
            y: {
                ticks: {
                    color: '#000',
                },
                grid: {
                    borderDash: [5, 5],
                    color: '#f8f8f8',
                },
            },
        },
    };

    return (
        <div className="bg-white p-4 rounded-lg">
            <h2 className="text-xl font-semibold text-black mb-4">Monthly Payment Frequency</h2>
            <Line data={data} options={options} />
        </div>
    );
};

export default PaymentFrequencyLineChart;
